// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"16a0758e","160":"643d2d14","208":"cfd34101","293":"e3d23cf4","516":"52dcb708","519":"3ab059f8","917":"e1da3401","946":"953305ec"}[chunkId] + ".chunk.js";
};